module.exports = __webpack_public_path__ + "media/images/voucher_background-bf5f5e76ef5cd5d7632ad29fef64fd03.png";